// extracted by mini-css-extract-plugin
export var messageSideLeft = "_nk-1";
export var messageSideRight = "_nk-2";
export var subscribeToBackInStockBubbleContainer = "_nk-0";